import { Instance } from 'mobx-state-tree';
import model from './model';
import views from './views';

const DevicePofile = model.views(views);

export interface IDevicePofile extends Instance<typeof DevicePofile> {}

export default DevicePofile;
